"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var composition_api_1 = require("@vue/composition-api");
var axios_1 = __importDefault(require("axios"));
var form_data_1 = __importDefault(require("form-data"));
var vee_validate_1 = require("vee-validate");
var rules_1 = require("vee-validate/dist/rules");
var ru_json_1 = __importDefault(require("vee-validate/dist/locale/ru.json"));
// Install required rule.
vee_validate_1.extend('required', rules_1.required);
// Install required_if rule.
vee_validate_1.extend('required_if', rules_1.required_if);
// Install numeric rule.
vee_validate_1.extend('numeric', rules_1.numeric);
// Install min_value rule.
vee_validate_1.extend('min_value', rules_1.min_value);
vee_validate_1.localize('ru', ru_json_1["default"]);
vee_validate_1.localize({
    ru: {
        messages: {
            required: 'Поле обязательно для заполнения',
            required_if: 'Поле обязательно для заполнения',
            numeric: 'Введите число',
            min_value: 'Значение должно быть больше нуля',
        },
        fields: {
            controller: {
                required_if: 'Выберите терморегулятор',
            }
        }
    }
});
vee_validate_1.configure({
    classes: {
        valid: 'is-valid',
        invalid: 'is-invalid'
    }
});
exports["default"] = composition_api_1.defineComponent({
    name: 'Calculator',
    components: {
        ValidationProvider: vee_validate_1.ValidationProvider,
        ValidationObserver: vee_validate_1.ValidationObserver
    },
    props: {},
    setup: function (props, context) {
        var state = composition_api_1.reactive({
            initialLoading: false,
            initialErrored: false,
            calculateLoading: false,
            calculateInProgress: false,
            calculateErrored: false,
            calculateCompleted: false,
            requestFormShow: false,
            requestFormSendning: false,
            requestFormErrored: false,
            requestFormCompleted: false
        });
        var initialLoading = composition_api_1.computed(function () { return state.initialLoading; });
        var initialErrored = composition_api_1.computed(function () { return state.initialErrored; });
        var calculationInProgress = composition_api_1.computed(function () { return state.calculateInProgress; });
        var calculateCompleted = composition_api_1.computed(function () { return state.calculateCompleted; });
        var calculateErrored = composition_api_1.computed(function () { return state.calculateErrored; });
        var requestFormShow = composition_api_1.computed(function () { return state.requestFormShow; });
        var requestFormSendning = composition_api_1.computed(function () { return state.requestFormSendning; });
        var requestFormErrored = composition_api_1.computed(function () { return state.requestFormErrored; });
        var requestFormCompleted = composition_api_1.computed(function () { return state.requestFormCompleted; });
        var roofMaterials = composition_api_1.ref({});
        var downpipeDiameters = composition_api_1.ref({});
        var controllers = composition_api_1.ref({});
        var heatingZoneWidths = composition_api_1.ref({});
        var result = composition_api_1.ref({});
        var selectedRoofMaterial = composition_api_1.ref('');
        var selectedHeatingZoneWidth = composition_api_1.ref('');
        var selectedDownpipeDiameter = composition_api_1.ref('');
        var selectedController = composition_api_1.ref('');
        var roofLength = composition_api_1.ref('');
        var guttersLength = composition_api_1.ref('');
        var downpipeLength = composition_api_1.ref('');
        var controlCabinetNeed = composition_api_1.ref(false);
        var person = composition_api_1.ref('');
        var phone = composition_api_1.ref('');
        var heatingZoneWidthsEmpty = composition_api_1.computed(function () { return Object.keys(heatingZoneWidths.value).length === 0; });
        var calculatorDataFilled = composition_api_1.computed(function () { return (roofMaterials || roofLength || downpipeLength) ? true : false; });
        composition_api_1.onMounted(function () {
            loadInitialData();
        });
        var loadInitialData = function () {
            state.initialLoading = true;
            axios_1["default"]
                .get('/calculator/getInitialData/')
                .then(function (response) {
                roofMaterials.value = response.data.roofMaterials;
                downpipeDiameters.value = response.data.downpipeDiameters;
                if (Object.keys(downpipeDiameters.value).length) {
                    selectedDownpipeDiameter.value = Object.keys(downpipeDiameters.value)[0];
                }
                controllers.value = response.data.controllers;
            })["catch"](function (error) {
                console.log(error);
                state.initialErrored = true;
            })
                .then(function () { return (state.initialLoading = false); });
        };
        composition_api_1.watch(selectedRoofMaterial, function (roofMaterial, prevRoofMaterial) {
            if (roofMaterial != '') {
                heatingZoneWidths.value = roofMaterials.value[roofMaterial].heatingWidth;
                if (Object.keys(roofMaterials.value[roofMaterial].heatingWidth).length === 1) {
                    selectedHeatingZoneWidth.value = Object.keys(roofMaterials.value[roofMaterial].heatingWidth)[0];
                }
            }
            else {
                selectedHeatingZoneWidth.value = '';
                heatingZoneWidths.value = {};
            }
        });
        var collectCalculatorData = function (form) {
            if (roofLength.value) {
                form.append('roofLength', roofLength.value);
            }
            if (selectedHeatingZoneWidth.value) {
                form.append('heatingZoneWidth', selectedHeatingZoneWidth.value);
            }
            if (guttersLength.value) {
                form.append('guttersLength', guttersLength.value);
            }
            if (downpipeLength.value && selectedDownpipeDiameter.value) {
                form.append('downpipeLength', downpipeLength.value);
                form.append('downpipeDiameter', selectedDownpipeDiameter.value);
            }
            if (selectedController.value) {
                form.append('controller', selectedController.value);
            }
            if (controlCabinetNeed.value) {
                form.append('controlCabinetNeed', controlCabinetNeed.value);
            }
        };
        var onCalculateSubmit = function () {
            state.calculateErrored = false;
            state.calculateInProgress = true;
            state.calculateCompleted = false;
            state.requestFormShow = false;
            state.requestFormErrored = false;
            state.requestFormCompleted = false;
            var form = new form_data_1["default"]();
            collectCalculatorData(form);
            axios_1["default"]
                .post('/calculator/getCalculateResult/', form)
                .then(function (response) {
                state.calculateCompleted = true;
                result.value = response.data;
            })["catch"](function (error) {
                console.log(error);
                state.calculateErrored = true;
            })
                .then(function () { return (state.calculateInProgress = false); });
        };
        var showRequestForm = function () {
            state.requestFormShow = true;
        };
        var onRequestSubmit = function () {
            state.requestFormSendning = true;
            var form = new form_data_1["default"]();
            collectCalculatorData(form);
            if (person.value) {
                form.append('person', person.value);
            }
            if (phone.value) {
                form.append('phone', phone.value);
            }
            axios_1["default"]
                .post('/udata/calculator/requestSend/', form)
                .then(function (response) {
                state.requestFormSendning = false;
                state.requestFormCompleted = true;
            })["catch"](function (error) {
                console.log(error);
                state.requestFormErrored = true;
                state.requestFormSendning = false;
            })
                .then(function () { return (state.requestFormSendning = false); });
        };
        return {
            initialLoading: initialLoading,
            initialErrored: initialErrored,
            calculationInProgress: calculationInProgress,
            calculateCompleted: calculateCompleted,
            calculateErrored: calculateErrored,
            result: result,
            roofMaterials: roofMaterials,
            downpipeDiameters: downpipeDiameters,
            controllers: controllers,
            heatingZoneWidths: heatingZoneWidths,
            heatingZoneWidthsEmpty: heatingZoneWidthsEmpty,
            selectedRoofMaterial: selectedRoofMaterial,
            selectedHeatingZoneWidth: selectedHeatingZoneWidth,
            selectedDownpipeDiameter: selectedDownpipeDiameter,
            selectedController: selectedController,
            roofLength: roofLength,
            guttersLength: guttersLength,
            downpipeLength: downpipeLength,
            controlCabinetNeed: controlCabinetNeed,
            calculatorDataFilled: calculatorDataFilled,
            onCalculateSubmit: onCalculateSubmit,
            person: person,
            phone: phone,
            showRequestForm: showRequestForm,
            requestFormShow: requestFormShow,
            requestFormSendning: requestFormSendning,
            requestFormErrored: requestFormErrored,
            requestFormCompleted: requestFormCompleted,
            onRequestSubmit: onRequestSubmit
        };
    }
});
